<template>
    <v-data-table :headers="headers" :items="messages.data" class="elevation-1" :loading="loading"
                  :no-data-text="loading ? 'Laster...' : 'Ingen data funnet.'"
                  no-results-text="Ingen resultater funnet."
                  :options.sync="options"
                  :server-items-length="messages.total"
                  :footer-props="footerProps"
                  :items-per-page="20">
        <template v-slot:item="{ item }">
            <tr>
                <td>
                    <div class="sms-list-text">{{ item.text }}</div>
                </td>
                <td>
                    <span v-if="item.sent_at">{{ formatDateTime(item.sent_at) }}</span>
                    <span v-else class="grey--text"><em>(i kø - ikke sendt)</em></span>
                </td>
                <td>{{ formatPhoneNumber(item.to) }}</td>
                <td>{{ item.customer.name }}</td>
                <td>
                    <span v-if="item.car_id">{{ item.car.reg_number }}</span>
                    <span v-else>&mdash;</span>
                </td>
                <td class="text-center">
                    <v-icon color="green" v-if="item.campaign_id">check_box</v-icon>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import {formatDateTime, formatPhoneNumber} from "@/helpers";
import {debounce} from "lodash";

export default {
    props: {
        customerId: {
            type: Number,
            required: false
        },
        carId: {
            type: Number,
            required: false
        },
        itemsPerPage: {
            type: Number,
            default: () => {
                return 25
            }
        }
    },

    data() {
        return {
            loading: false,
            messages: {},
            options: {
                page: 1,
                itemsPerPage: this.itemsPerPage,
                sortBy: ['sent_at'],
                sortDesc: [true]
            }
        }
    },

    created() {
        this.loadData();
    },

    methods: {
        formatDateTime,
        formatPhoneNumber,
        loadData: debounce(function () {
            let params = {
                ...this.options,
                customer: this.customerId,
                car: this.carId
            };
            this.loading = true;
            this.$http.get(`sms`, {params}).then(response => {
                this.messages = response.data;
                console.log(this.messages);
            }).finally(() => {
                this.loading = false;
            })
        }, 250)
    },

    watch: {
        'options.itemsPerPage'(a, b) {
            if (a === b) return;
            this.loadData();
        },
        'options.page'(a, b) {
            if (a === b) return;
            this.loadData();
        }
    },

    computed: {
        headers() {
            return [
                {text: 'SMS', value: 'text', sortable: false},
                {text: 'Sendt', value: 'sent_at', sortable: false},
                {text: 'Tlf.', value: 'to', sortable: false},
                {text: 'Kunde', value: 'customer_id', sortable: false},
                {text: 'Bil', value: 'car_id', sortable: false},
                {text: 'Kampanje', value: 'campaign_id', sortable: false, align: 'center'},
            ];
        },

        footerProps() {
            return {
                'items-per-page-text': 'Meldinger per side:',
                'items-per-page-options': [25, 100, 500]
            }
        },
    },
}
</script>

<style lang="scss">
.sms-list-text {
    white-space: pre-line;
    line-height: 120%;
    padding: 0.5rem 0;
    max-height: 70px;
    overflow-y: auto;
}
</style>
